import type { UserAccountData } from '@/firebase/auth/user-account-data'

/**
 * Organization id for matter-sharing analytics events.
 *
 * Uses `orgData.id` only — the same source as `OrganizationInviteSent` — so org-level
 * collaboration dashboards join on one key. See analytics/README.md ("Matter collaboration").
 */
export function getCollaborationOrganizationId(userAccountData: UserAccountData | null | undefined): string {
  return userAccountData?.orgData?.id ?? ''
}
